import {observable, action} from 'mobx';
import _ from 'lodash';

class McqSessionFiltersStore {
  @observable theme_ids = [];
  @observable filter_type = 'all_questions';

  @action
  setThemes = (themes) => {
    this.theme_ids = themes;
  };

  @action
  setFilterType = (type) => {
    this.filter_type = type;
  };

  @action
  clearFilters = () => {
    this.theme_ids = [];
    this.filter_type = 'all_questions';
  }
};

export default new McqSessionFiltersStore();



// WEBPACK FOOTER //
// ./src/stores/McqSessionFiltersStore.js